
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ecommerce-seo-agency",
      function () {
        return require("private-next-pages/ecommerce-seo-agency/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ecommerce-seo-agency"])
      });
    }
  